import { FC, HTMLAttributes, ReactNode } from 'react';

import { Flex } from 'antd';

import { EOnboardingSteps, StepOne, StepThree, StepTwo, useOnboardingSlice } from 'features/Onboarding';

interface IStepsProps extends HTMLAttributes<HTMLDivElement> {}

export const Steps: FC<IStepsProps> = ({ className, ...props }) => {
	const { step } = useOnboardingSlice();

	const steps: Record<EOnboardingSteps, ReactNode> = {
		[EOnboardingSteps.FIRST]: <StepOne />,
		[EOnboardingSteps.SECOND]: <StepTwo />,
		[EOnboardingSteps.THIRD]: <StepThree />,
	};

	return (
		<Flex {...props} vertical gap={32} className={className}>
			{steps[step]}
		</Flex>
	);
};
